export function upgrade_prototype() {
    HTMLElement.prototype.digest = function() {
        return Graphite.hash(this.innerHTML);
    }

    HTMLElement.prototype.fadeOut = function(duration = 600, cb) {
        let keyframes = [
            {"opacity": 1},
            {"opacity": 0}
        ]

        let settings = {
            duration: duration,
            iterations: 1,
            fill: 'both'
        }

        let animation = this.animate(keyframes, settings);  

        if (typeof cb === 'function') {
            animation.addEventListener('finish', evt => {
                cb();
            })
        }

        return this;      
    }

    HTMLElement.prototype.fadeIn = function(duration = 600, cb) {    
        let keyframes = [
            {"opacity": 0},
            {"opacity": 1}
        ]

        let settings = {
            duration: duration,
            iterations: 1,
            fill: 'both'
        }

        let animation = this.animate(keyframes, settings);  

        if (typeof cb === 'function') {
            animation.addEventListener('finish', evt => {
                cb();
            })
        }

        return this;      
    }

    HTMLElement.prototype.custom_animate = function(keyframes, duration = 600, cb) {
        let settings = {
            duration: duration,
            iterations: 1,
            fill: 'both'
        }

        let animation = this.animate(keyframes, settings);  

        if (typeof cb === 'function') {
            animation.addEventListener('finish', evt => {
                cb();
            })
        }

        return this;      
    }

    HTMLElement.prototype.on = function(event, cb) {
        if (event == 'blocks-ready') {
            let blocks = this.closest('[data-widget="wx-sub-page"]');

            if (!blocks) {
                blocks = this.closest('[data-widget="wx-blocks"]');
            }

            if (blocks && blocks.classList.contains('ready')) {
                cb();
            } else {
                let blocks_ready = () => {
                    let blocks = this.closest('[data-widget="wx-blocks"]');

                    if (blocks) {
                        return blocks.classList.contains('ready');
                    }

                    return false;
                }

                Graphite.wait_until(blocks_ready).then(() => {
                    cb();
                })
            }
        } else if (event == 'items-ready') {
            let items = this.querySelector('wx-items');

            if (items && this.classList.contains('ready')) {
                cb();
            } else {
                let items_ready = () => {
                    let items = this.querySelector('wx-items');

                    if (items) {
                        return this.classList.contains('ready');
                    }

                    return false;
                }

                Graphite.wait_until(items_ready).then(() => {
                    cb();
                })
            }
        } else if (event == 'ready') {
            if (this.classList.contains('ready')) {
                cb();
            } else {
                let on_ready = () => {
                    cb();
                    this.removeEventListener('ready', on_ready);
                }

                this.addEventListener(event, on_ready);

                // this.addEventListener(event, cb);
            }
        } else {
            this.addEventListener(event, cb);
        }
    }

    HTMLElement.prototype.off = function(event, cb) {
        this.removeEventListener(event, cb);
    }

    HTMLElement.prototype.ready = function() {
        this.classList.add('ready');
        this.trigger('ready');
    }

    HTMLElement.prototype.query = function(selector) {
        return this.querySelector(selector);
    }

    HTMLElement.prototype.queryAll = function(selector) {
        return this.querySelectorAll(selector);
    }

    HTMLElement.prototype.hasClass = function(cls) {
        return this.classList.contains(cls);
    }

    HTMLElement.prototype.show = function() {
        return this.classList.remove('d-none');
    }

    HTMLElement.prototype.hide = function() {
        return this.classList.add('d-none');
    }

    HTMLElement.prototype.addClass = function(cls) {
        let arr = cls.split(' ');

        arr.forEach(item => {
            this.classList.add(item.trim());
        })
    }

    HTMLElement.prototype.removeClass = function(cls) {
        let arr = cls.split(' ');

        arr.forEach(item => {
            this.classList.remove(item.trim());
        })
    }

    HTMLElement.prototype.html = function(html) {
        if (typeof html == 'string') {
            this.innerHTML = html;
          
            Array.from(this.querySelectorAll("script"))
                .forEach(oldScriptEl => {
                    const newScriptEl = document.createElement("script");
                    Array.from(oldScriptEl.attributes).forEach( attr => {
                    newScriptEl.setAttribute(attr.name, attr.value) 
                })
              
                const scriptText = document.createTextNode(oldScriptEl.innerHTML);
                newScriptEl.appendChild(scriptText);  
                oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
            })

            return;
        }

        return this.innerHTML.remove_lit();
    }

    HTMLElement.prototype.text = function(str) {
        if (typeof str == 'string') {
            this.innerText = str;
            return;
        }

        return this.innerText;
    }

    HTMLElement.prototype.wrap = function(wrapper) {
        this.parentNode.insertBefore(wrapper, this);
        wrapper.appendChild(this);
    }

    HTMLElement.prototype.unwrap = function() {
        this.replaceWith(...this.childNodes);
    }

    HTMLElement.prototype.attr = function(key, value) {
        if (typeof value == 'string') {
            this.setAttribute(key, value);
            return;
        }

        return this.getAttribute(key);
    }

    HTMLElement.prototype.css = function(styles = {}) {
        if (typeof styles == 'object') {
            Object.keys(styles).forEach(key => {
                this.style.setProperty(key, styles[key]);
            })
        }
    }

    HTMLElement.prototype.trigger = function(event_name, data = {}, bubbles = false) {
        this.dispatchEvent(new CustomEvent(event_name, {detail: data, bubbles: bubbles}));
    }

    HTMLElement.prototype.create_reactive_state = function() {
        this.state = Graphite.create_reactive_state({}, (prop, current_state, prev_state) => {
            this.trigger('state-changed', {
                prop: prop,
                current_state: current_state,
                prev_state: prev_state
            })
        })

        return this.state;    
    }

    HTMLElement.prototype.get = function(url, cached = true) {
        let options = {};

        if (!cached) {
            options = {cache: "no-cache"}
        }

        fetch(url, options)
            .then(response => response.text())
            .then(html => {
                this.html(html);
            })
            .catch(err => console.log(err));
    }

    HTMLElement.prototype.detatch = function() {
        return this.parentElement.removeChild(this);        
    }

    HTMLElement.prototype.getHash = function() {
        return new Promise(resolve => {
            let node = this.data()

            Graphite.hash(JSON.stringify(node)).then(hash => {
                resolve(hash.substr(0, 24));
            })
        })
    }

    HTMLElement.prototype.hash = function() {
        this.getHash().then(hash => {
            if (hash) {
                this.setAttribute('data-hash', hash);
            }
        })
    }

    HTMLElement.prototype.is_changed = function() {
        return new Promise(resolve => {
            let hash = this.getAttribute('data-hash');
            
            this.getHash().then(new_hash => {
                resolve(hash != new_hash);
            })
        })
    }

    HTMLElement.prototype.save = function(url) {
        if (this.matches('[data-id][data-widget]')) {
            let id = this.getAttribute('data-id');
            let data = this.data();

            data.id = id;

            return Graphite.post_json(url, data);
        }

        return Promise.resolve(null);
    }

    HTMLElement.prototype.reload = function() {
        return new Promise(resolve => {
            let id = this.getAttribute('data-id');
            let widget = this.getAttribute('data-widget');
            let extra = this.getAttribute('data-extra');

            if (id && widget) {
                let slot = this.closest('wx-slot');

                if (slot) {
                    let item = this.closest('wx-item');

                    if (item) {
                        Graphite.get_html('./process/get-widget.php?id=' + id + '&widget=' + widget + '&extra=' + extra).then(html => {
                            let toolbar = item.querySelector('& > [data-role="toolbar"]');

                            if (toolbar) {
                                toolbar.querySelectorAll('span').forEach(span => {
                                    if (!span.classList.contains('drag-handle')) {
                                        span.remove();
                                    }
                                })
                            }

                            this.remove();
                            slot.html(html);

                            setTimeout(() => {
                                slot.querySelectorAll('.lazy').forEach(img => {
                                    Graphite.lazy_load(img);
                                })                                
                            }, 100)

                            resolve(slot.querySelector('wx-widget'));
                        })
                    } else {
                        let block = this.closest('wx-block');

                        if (block) {
                            Graphite.get_html('./process/get-widget.php?id=' + id + '&widget=' + widget).then(html => {
                                let toolbar = block.querySelector('& > [data-role="toolbar"]');

                                toolbar.querySelectorAll('span').forEach(span => {
                                    if (!span.classList.contains('drag-handle')) {
                                        span.remove();
                                    }
                                })

                                this.fadeOut(300, () => {
                                    this.remove();
                                    slot.html(html);

                                    setTimeout(() => {
                                        slot.querySelectorAll('.lazy').forEach(img => {
                                            Graphite.lazy_load(img);
                                        })                                
                                    }, 100)

                                    resolve(slot.querySelector('wx-widget'));
                                })
                            })
                        } else {
                            Graphite.get_html('./process/get-widget.php?id=' + id + '&widget=' + widget).then(html => {
                                this.fadeOut(300, () => {
                                    this.remove();
                                    slot.html(html);
                                    resolve(slot.querySelector('wx-widget'));
                                })
                            })                    
                        }
                    }
                } 
            }
        })
    }

    HTMLElement.prototype.is_visible = function() {
        return this.offsetParent != null;
    }

    NodeList.prototype.on = function(event, cb) {
        this.forEach(el => {
            el.addEventListener(event, cb);
        })
    }

    NodeList.prototype.addClass = function(cls) {
        let arr = cls.split(' ');

        this.forEach(el => {
            arr.forEach(item => {
                el.classList.add(item.trim());
            })        
        })
    }

    NodeList.prototype.removeClass = function(cls) {
        let arr = cls.split(' ');

        this.forEach(el => {
            arr.forEach(item => {
                el.classList.remove(item.trim());
            })        
        })
    }

    NodeList.prototype.off = function(event, cb) {
        this.forEach(el => {
            this.removeEventListener(event, cb);
        })
    }

    NodeList.prototype.attr = function(key, value) {
        this.forEach(el => {
            if (value == null) {
                el.removeAttribute(key);
            } else {
                el.setAttribute(key, value);
            }
        })
    }

    NodeList.prototype.css = function(styles = {}) {
        if (typeof styles == 'object') {
            let keys = Object.keys(styles);
            
            this.forEach(el => {
                keys.forEach(key => {
                    el.style.setProperty(key, styles[key]);
                })            
            })
        }
    }

    HTMLDocument.prototype.on = function(event, cb) {
        if (event == 'app-ready') {
            if (Graphite.state.get('ready')) {
                cb();
            } else {
                this.addEventListener(event, cb);    
            }
        } else {
            this.addEventListener(event, cb);
        }
    }

    HTMLDocument.prototype.off = function(event, cb) {
        this.removeEventListener(event, cb);
    }

    HTMLDocument.prototype.query = function(selector) {
        return this.querySelector(selector);
    }

    HTMLDocument.prototype.queryAll = function(selector) {
        return this.querySelectorAll(selector);
    }

    HTMLDocument.prototype.trigger = function(event_name, data = {}, bubbles = false) {
        this.dispatchEvent(new CustomEvent(event_name, {detail: data, bubbles: bubbles}));
    }

    HTMLDocument.prototype.ready = (cb) => {
        if (document.readyState === 'complete') {
            cb();
        } else {
            let on_content_loaded = () => {
                setTimeout(() => {
                    cb();
                }, 100)

                document.removeEventListener('DOMContentLoaded', on_content_loaded);
            }

            document.addEventListener('DOMContentLoaded', on_content_loaded);
        }
    }

    String.prototype.base64_encode = function(){return btoa(this)}
    String.prototype.base64_decode = function(){return atob(this)}

    String.prototype.parse = function(params) {
        const names = Object.keys(params);
        const vals = Object.values(params);
        return new Function(...names, `return \`${this}\`;`)(...vals);
    }

    String.prototype.remove_lit = function() {
        return this.replace(/<!--\?.*-->/g, '');
    }

    String.prototype.toObject = function() {
      return JSON.parse(unescape(atob(this)));
    }

    /*
    Object.prototype.zerialize = function() {
      return btoa(escape(JSON.stringify(this)));  
    }
    */
}